let token = "Bearer ";

// TODO - switch to api.regis-co.com on prod
const url = window.location.host.indexOf("localhost") >= 0 ? new URL("http://regis.qa.regis-co.com") : new URL(window.location.href);
const forceSandbox = window.location.origin.indexOf("portal.regis-co.com") >= 0 ||
  window.location.origin.indexOf("portal.insecure.regis-co.com") >= 0 ||
  window.location.origin.indexOf("studio.regis-co.com") >= 0 ||
  window.location.origin.indexOf("studio.insecure.regis-co.com") >= 0;

const simgateUrl = (forceSandbox && "https://sandbox-api.regis-co.com") || window.trcAppSettings.simgateUrl || (url.protocol + "//" + url.host.substring(0, url.host.indexOf(".")).replace("-enterprise", "") + "-api" + url.host.substring(url.host.indexOf(".")));

try {
  token = window.localStorage.getItem("SIMGATE_TOKEN") || token;
}
catch (e) { }

export const send = async (path, method = "GET", body = {}, headers = {}) => {

  const start = new Date().getTime();
  const response = await fetch(`${simgateUrl}/api/simgate${path}`, {
    method,
    headers: {
      "Content-Type": "application/json",
      "Authorization": token
    },
    body: method !== "GET" && body ? (typeof body !== "string" ? JSON.stringify(body) : body) : undefined,
  });

  if (response.headers.get("Authorization")) {
    token = response.headers.get("Authorization");
    try {
      window.localStorage.setItem("SIMGATE_TOKEN", token);
    }
    catch (e) { }
  }

  let result = await response.text();

  try {
    result = JSON.parse(result);
    if (result.error) {
      result = result.error;
      result.error = true;
    }
    if (result.result) {
      result = result.result;
    }
  }
  catch (e) {
    console.error(e);
    console.error(result);
    result = {
      error: true,
      number: response.status,
      message: result
    }
  }

  const end = new Date().getTime();

  console.log(`${path} - Status: ${response.status}, Time: ${end - start}, Result: ${JSON.stringify(result)}`);
  return [result, response];
}

export const getContext = () => {
  return send("/security/getContext", "POST", { select: "user.*" });
}

export const signOut = () => {
  return send("/security/signout", "POST", {});
}

export const signIn = async ({ username, password }) => {
  let [result, response] = await send("/security/signin", "POST", { username, password });

  if (result?.context?.userId && !result?.error) {
    const [userResult] = await send("/user/select", "POST", { where: { id: result.context.userId } });
    if (userResult?.selected?.[0]?.num4 === 1) {
      window.localStorage.setItem("SIMGATE_TOKEN", "Bearer ");
      result = {
        error: true,
        number: 404,
        message: "not-found"
      }
    }
  }

  return [result, response];
}

export const recoverPassword = async (options) => {

  const url = getOverloadedParam("dashboardUrl", { defaultValue: "https://api2.regis-co.com/v1/dashboard-stream/", asUrl: true, path: "passwordresetemail/" });
  const response = await fetch(url.href, {
    method: "POST",
    headers: {
      "Content-Type": "application/json"
    },
    body: JSON.stringify(options)
  });

  const result = await response.json();
  return [result, response];

  /*const date = new Date();
  date.setDate(date.getDate() + 1);
  return send("/security/forgotpassword", "POST", {
    code: "Regis123",
    expirationDate: date.toISOString(),
    language: "en-us",
    method: "email",
    tokenType: 1,
    username
  });*/
}

export const resetPassword = ({ password, token }) => {
  return send("/security/forgotpassword", "POST", {
    code: "Regis123",
    password,
    token
  });
}

export const changePassword = ({ password }) => {

}

export const register = ({ email, firstName, lastName, password }) => {
  return send("/user/create", "POST", {
    create: {
      email,
      firstName,
      lastName,
      password,
      roleID: 2,
      username: email
    }
  });
}

export const getPathsForUser = (options) => {
  return send("/path/getForUser", "POST", options);
}

export const anonLogin = async (options) => {

  const url = getOverloadedParam("anonUrl", { defaultValue: "https://api2.regis-co.com/v1/anon/", asUrl: true, path: "login/" });
  const response = await fetch(url.href, {
    method: "POST",
    headers: {
      "Content-Type": "application/json"
    },
    body: JSON.stringify(options)
  });

  const result = await response.json();
  token = result.authToken;
  try {
    window.localStorage.setItem("SIMGATE_TOKEN", token);
    window.localStorage.setItem("ANON_USER_ID", result?.context?.userId);
  }
  catch (e) { }
  return result;
}

export const scormLogin = async (options) => {
  const url = getOverloadedParam("scormAPI", { defaultValue: "https://api2.regis-co.com/v1/scorm/", asUrl: true, path: "login/" });
  const response = await fetch(url.href, {
    method: "POST",
    body: JSON.stringify(options)
  });

  const result = await response.json();
  token = result.authToken;
  try {
    window.localStorage.setItem("SIMGATE_TOKEN", token);
  }
  catch (e) { }
  return result;
}

export const reviewerLogin = async (options) => {
  const url = getOverloadedParam("studioLoginApi", { defaultValue: "https://api2.regis-co.com/v1/authoringlogin/", asUrl: true, path: "reviewer/" });
  const response = await fetch(url.href, {
    method: "POST",
    body: JSON.stringify(options)
  });

  const result = await response.json();
  token = result.authToken;
  try {
    window.localStorage.setItem("SIMGATE_TOKEN", token);
  }
  catch (e) { }
  return result;
}